import { gql } from '@apollo/client';

export * from './assetReport.query.generated';

export const ASSET_REPORT = gql`
  query assetReport($softwareEscrowId: ID!, $assetReportId: ID!) {
    assetReport(softwareEscrowId: $softwareEscrowId, assetReportId: $assetReportId) {
      id
      createdAt
      period
      asset {
        id
        depositSource
      }
      data {
        collaborators
        commitsPerDay
        languages
        size
        totalCommits
      }
    }
  }
`;
